/**
 * Header components.
 */
import React from 'react';
import { render } from 'react-dom';
import domContentLoaded from 'utils/domContentLoaded';
import reactComponentManager from 'utils/reactComponentManager';
import HeaderSearch from '../../components/header/components/header-search';
import Trending from '../../components/header/components/trending';
import StickyHeader from '../../components/header/components/sticky-header';
import '../../scss/header/index.scss';

domContentLoaded(() => {
  reactComponentManager({
    Trending,
  });
  const el = document.querySelector('[data-react-component="HeaderSearch"]');
  const props = JSON.parse(el.dataset.props);

  render(
    <HeaderSearch {...props} />,
    el
  );
});

if (module.hot) {
  module.hot.accept();

  reactComponentManager({
    Trending,
    StickyHeader,
  });
}

